import 'babel-polyfill';
// import 'core-js'
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import 'url-search-params-polyfill';
// import '@webcomponents/webcomponentsjs/webcomponents-bundle.js';
import '@webcomponents/shadydom/src/shadydom.js';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import 'proxy-polyfill';
// import 'core-js/features/global-this';
// import 'core-js';
// if (typeof globalThis === 'undefined') {
//
// }
import 'regenerator-runtime/runtime';

if (typeof globalThis === 'undefined') {
    (window as any).globalThis = window;
}
// var globalThis = window;
// 如果使用了异步函数，还需要引入 regenerator-runtime


// if (typeof Number.isNaN as any === 'undefined') {
//     Number.isNaN = isNaN
// }

export {

}